import { render } from "./Option.vue?vue&type=template&id=081d819f&scoped=true"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"

import "./Option.vue?vue&type=style&index=0&id=081d819f&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081d819f"]])

export default __exports__